module.exports = __webpack_public_path__ + "files/administrator-windows-werver-2003.b3b6c376.pdf";